import React from 'react';

const Mouth1 = ({scale, mouthColorTop, mouthColorBottom, className}) => {
    return (
        <svg
        className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={scale ? (225.142 * scale) : "225.142"}
            height={scale ? (85.999 * scale) : "85.999"}
            viewBox="99.022 165.119 228.142 85.999"
        >
            <g stroke="#000">
                <path
                    d="M236.926 218.3q5.154 4.755 10.307 0l29.338-27.069q5.154-4.755-5.154-4.755h-58.675q-10.308 0-5.154 4.755z"
                    transform="translate(-26.984 28.793)"
                    stroke={mouthColorTop} fill={mouthColorTop}
                ></path>
                <path
                    d="M242.611 222.324s17.385-12.864 16.758-16.681c-.458-2.788-7.476-4.678-11.318-5.572a24.028 24.028 0 00-10.884 0c-3.824.896-10.788 2.789-11.244 5.573-.626 3.818 16.688 16.68 16.688 16.68s0 0 0 0"
                    transform="translate(-26.984 28.793)"
                    stroke={mouthColorBottom} fill={mouthColorBottom}
                ></path>
            </g>
        </svg>
    );
};

export default Mouth1;